import React from 'react'

import { useCompassMetadataOrFail } from '@/components/flows/CompassFlow/hooks/useCompassMetadataOrFail'
import CompanyLogoOrName from '@/components/misc/CompanyLogoOrName'
import RequestCompanyCallbackButton from '@/components/misc/RequestCompanyCallbackButton/RequestCompanyCallbackButton'
import { Card, CardContent } from '@/components/ui/card'
import { useClientMetadata } from '@/hooks/useClientMetadata'
import { cn } from '@/lib/utils'
import {
  CompassReportItem,
  LatestCompassReportItem,
} from '@/types/responses/compass-reports'

interface Props {
  compassReport: CompassReportItem | LatestCompassReportItem
  className?: string
  variant?: 'card' | 'plain'
}

const CompassSponsorCompany: React.FC<Props> = ({
  compassReport,
  className,
  variant,
}) => {
  const clientMetadata = useClientMetadata()
  const compassMetadata = useCompassMetadataOrFail()

  if (!clientMetadata && !compassMetadata) {
    return null
  }

  const sponsorCompany =
    clientMetadata?.sponsorCompany ?? compassMetadata.company

  if (!sponsorCompany) {
    return null
  }

  const isCardVariant = variant === 'card'
  const isPlainVariant = variant === 'plain'

  const render = () => {
    return (
      <div className={cn('flex flex-col items-center gap-4', className)}>
        <div className="text-center">
          {isPlainVariant && (
            <div className="mb-2 font-medium">Introduced by:</div>
          )}

          <CompanyLogoOrName
            name={sponsorCompany.presentationName}
            logoUrl={sponsorCompany.logoUrl}
            showNameFallback={true}
            showLogoFallback={false}
            imageStyle={{
              maxWidth: '190px',
              maxHeight: '60px',
            }}
            fallbackProps={{
              className: 'text-body-base justify-center',
            }}
          />
        </div>

        <RequestCompanyCallbackButton
          compassReport={compassReport}
          compassPartner={sponsorCompany}
          isCreateReferral={false}
        />
      </div>
    )
  }

  if (isCardVariant) {
    return (
      <Card className="mb-4 inline-block p-0">
        <CardContent className="px-5 pt-4 pb-6">{render()}</CardContent>
      </Card>
    )
  }

  return render()
}

export default CompassSponsorCompany
